import React from "react";
import Storage from "../../services/storage.service";
import Translations from "../../services/translation.service";
import FirebaseAnalytics from "../../services/analytics.service";
import SorryBanner from "../../assets/img/SorryBanner.png";
import SpinnerTimeLoader from "../shared/timeLoading";

const EligibilityFailed = props => {
  let isMnp = false;
  if (Storage.get("flags") && Storage.get("flags").IsMnp) {
    isMnp = true;
  }

  let prefix = "3.3.2.B_";
  let content = (
    <div className="stf-eligibility-cntnr">
      <img src={SorryBanner} alt="" />
      <div className="storefront-title-container">
        <h2>{Translations.keys[prefix + "error_title"]}</h2>
        <p>{Translations.keys[prefix + "error_mnp_desc"]}<br />
          <u>{Translations.keys[prefix + "error_mnp_desc2"]}</u>
          {Translations.keys[prefix + "error_mnp_desc3"]}<br />
        </p>
      </div>
      <div className="stf-eligibility-failed-table">
        <div className="stf-eligibility-cell">
          <div className="stf-eligibility-cell-label">
            {Translations.keys["scr_3.3.1_Check_Eligibility_nationality"]}
          </div>
          <div className="stf-eligibility-cell-value">
            {props.selectedNationalityText}
          </div>
        </div>
        <div className="stf-eligibility-cell">
          <div className="stf-eligibility-cell-label">
            {Translations.keys["scr_3.3.1_Check_Eligibility_id_type"]}
          </div>
          <div className="stf-eligibility-cell-value">
            {props.selectedIdTypeText}
          </div>
        </div>
        <div className="stf-eligibility-cell">
          <div className="stf-eligibility-cell-label">
            {Translations.keys["scr_3.3.1_Check_Eligibility_id_number"]}
          </div>
          <div className="stf-eligibility-cell-value">{props.id_number}</div>
        </div>
        <div className="stf-eligibility-cell">
          <div className="stf-eligibility-cell-label">
            {Translations.keys["scr_3.3.1_Check_Eligibility_cities"]}
          </div>
          <div className="stf-eligibility-cell-value">{props.selectedCityText}</div>
        </div>
      </div>
      <div className="stf-eligibility-form-btn-area">
        {isMnp ? (
          <button
            className={"common-button"}
            onClick={() => {
              FirebaseAnalytics.button_clicked(
                prefix + "btn_continue"
              )
              props.skipEligibility()
            }}
          >
            {Translations.keys[prefix + "btn_continue"]}
          </button>
        ) : (
          <button
            className={"common-button"}
            onClick={() => {
              FirebaseAnalytics.button_clicked(
                prefix + "btn_port_my_number"
              );
              props.requestMNPAgain()
            }}
          >
            {Translations.keys[prefix + "btn_port_my_number"]}
          </button>
        )}
        <button
          className={"common-button-light"}
          onClick={() => {
            FirebaseAnalytics.button_clicked(
             prefix + "btn_reenter_info"
            );
            props.re_enter_data("EligibityForm")
          }}
        >
          {Translations.keys[prefix + "btn_reenter_info"]}
        </button>
      </div>
    </div>
  );
  if (props.loading) {
    content = <SpinnerTimeLoader />
  }
  return content;
};
export default EligibilityFailed;
